import type { FetchRequestError } from "@lib/errors";
import { FetchUserEncodedError } from "@lib/errors/FetchUserEncodedError";
import type { SHARED_CONSTANTS_CUSTOM_DOMAIN_MIGRATION_ERRORS } from "@lib/shared_constants";

export interface UsersSubscriptionGroupsIdResult {
  info: string;
}

export type PostUsersSubscriptionGroupsIdMigratingDomainError = FetchUserEncodedError<
  SHARED_CONSTANTS_CUSTOM_DOMAIN_MIGRATION_ERRORS["MIGRATING_DOMAIN"],
  { link_shortening_domain: string }
>;

export type PostUsersSubscriptionGroupsIdErrors = PostUsersSubscriptionGroupsIdMigratingDomainError;

export const isPostUsersSubscriptionGroupsIdError = (
  error: FetchRequestError
): error is PostUsersSubscriptionGroupsIdErrors => {
  return error instanceof FetchUserEncodedError;
};

export interface PostUsersSubscriptionGroupsIdProps {
  id?: string;
  app_group_id: string;
  description?: string;
  name: string;
  external_id?: string;
  link_shortening_domain?: string;
  allow_list?: string[];
}
